module.exports = __webpack_public_path__ + "static/media/bigbuckbunny_snapshot1.0628aab2.jpg";